export default "__VITE_ASSET__BCq7d9hc__"